import { Link } from 'react-router-dom';
import { Button, Header, Icon, Segment } from 'semantic-ui-react';

export default function AccessDenied() {
  return (
    <Segment placeholder>
      <Header icon>
        <Icon name="low vision" />
        <p>Oops - Sorry</p>
        <p>
          "Access Denied", "You need permission to access this page," please
          contact your administrator for assistance in gaining access to your
          account.
        </p>
      </Header>
      <Segment.Inline>
        <Button as={Link} to="/mediaAssets" primary>
          Return to Home page
        </Button>
      </Segment.Inline>
    </Segment>
  );
}
